<template>
  <main class="view users">
    <div class="descriptor">
      <h1>{{ $t('branches.headline') }}</h1>
      <p>{{ $t('branches.copy') }}</p>
      <Button primary @click="createBranch">{{ $t('branches.buttons.newBranch') }}</Button>
    </div>
    <List
      :filters="computedListFilters"
      :structure="computedStructure"
      :data="computedListData"
      :sort.sync="sort"
      @interaction="handleListInteraction"
      @select="handleItemSelect"
      @reload="reload"
      @context="handleListContext"
    />
  </main>
</template>

<script>
  import StatusUser from '@/components/ui/StatusUser';
  import List from '@/components/ui/list/List';
  import ToggleBar from '@/components/ui/inputs/ToggleBar';
  import Button from '@/components/ui/inputs/Button';
  import Sort from '@/utils/Sort';
  import VueUtil from '@/utils/VueUtil';
  import ModalBranchesCreateEdit from '@/components/branches/ModalBranchesCreateEdit';
  import ContextMenu from '@/components/ui/inputs/ContextMenu';

  export default {
    name: 'Branches',
    components: {
      Button,
      ToggleBar,
      List,
      StatusUser,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        branches: [],
        filters: {},
        sort: {
          property: 'name',
          ascending: true,
        },
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      computedStructure() {
        const columnLabels = this.$i18n.t('branches.list.labels');
        return {
          name: {
            label: columnLabels.name,
          },
          state: {
            label: columnLabels.state,
          },
          district: {
            label: columnLabels.district,
          },
          active: {
            label: columnLabels.active,
            sort: Sort.list.number,
          },
          completed: {
            label: columnLabels.completed,
            sort: Sort.list.number,
          },
          archived: {
            label: columnLabels.archived,
            sort: Sort.list.number,
          },
          users: {
            label: columnLabels.users,
            sort: Sort.list.number,
          },
        };
      },
      computedListFilters() {
        // const globalLabels = this.$i18n.t('labels');
        // const filterLabels = this.$i18n.t('users.list.filters');
        return [];
      },
      computedListActions() {
        return [
          { action: 'edit', icon: 'edit', label: 'Bearbeiten' },
        ];
      },
      computedListData() {
        const filters = this.filters;
        const branches = this.branches;
        if (branches) {
          let out = (branches || []).slice();
          if (filters.status && filters.status !== 'all') {
            out = out.filter(e => e.locked === (filters.status !== 'active'));
          }
          if (filters.role?.length > 0) {
            out = out.filter(e => filters.role.includes(e.role));
          }
          if (filters.search) {
            const search = filters.search.toLowerCase();
            out = out.filter(e => e.firstname.toLowerCase().includes(search)
              || e.lastname.toLowerCase().includes(search));
          }
          return out;
        }
        return null;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    async created() {
      this.branches = await this.$sav.api.get('/branches');
    },
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      async reload() {
        this.branches = null;
        this.branches = await this.$sav.api.get('/branches');
      },
      createBranch() {
        const modal = VueUtil.createComponent(ModalBranchesCreateEdit, document.body, {
          propsData: {},
          parent: this,
        });
        modal.$once('done', async () => { this.reload(); });
      },
      async executeAction(action, reference) {
        switch (action) {
          case 'edit': {
            const modal = VueUtil.createComponent(ModalBranchesCreateEdit, document.body, {
              propsData: { uuid: reference.uuid },
              parent: this,
            });
            modal.$once('done', async () => { this.reload(); });
            break;
          }
          default: {
            console.log(action, reference);
            break;
          }
        }
      },
      //----------------------------------
      // Event Handlers
      //----------------------------------
      handleListInteraction(data) {
        const { id, value } = data;
        const filters = Object.assign({}, this.filters);
        filters[id] = value;
        this.filters = filters;
      },
      handleItemSelect(data) {
        this.executeAction('edit', data);
      },
      handleListContext(evt) {
        const { currentTarget, row } = evt;
        const actions = this.computedListActions;
        const context = VueUtil.createComponent(ContextMenu, document.body, {
          propsData: {
            origin: currentTarget,
            reference: row,
            actions,
          },
          parent: this,
        });

        context.$once('action', (action, reference) => {
          context.destroy();
          this.executeAction(action, reference);
        });
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.view.users {
}
</style>
